var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.period)?_c('div',{staticClass:"nearest-place-clue",style:(Object.assign({}, _vm.style))},[_c('span',{staticClass:"iconify",attrs:{"data-width":"22","data-height":"22","data-icon":"material-symbols:add-rounded"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }